import { memo } from "react";
import Mask from "react-text-mask";

export type MaskType = (string | RegExp)[];

type MaskedInputProps = {
  readonly mask: MaskType;
  readonly inputRef: (ref: HTMLInputElement | null) => void;
};

export const MaskedInput = memo<MaskedInputProps>(
  ({ inputRef, ...restProps }) => (
    <Mask
      {...restProps}
      showMask
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
    />
  )
);
